<script>
  import BusinessItem from '~/components/business/business-item.svelte'
  import { aboutBusinessList } from '../about-business'
</script>

<ul class="business-list | row row-wrap -mx-2 justify-center lg:-mx-2">
  {#each aboutBusinessList as { title, description }}
    <li class="business-item | w-full md:w-2/4 lg:w-1/3">
      <div class="m-2 grow">
        <article>
          <BusinessItem {title} {description} />
        </article>
      </div>
    </li>
  {/each}
</ul>
